<template>
  <modal-block modal-id="ModalBooking" close-button="yes">
    <template v-slot:content>

      <div class="bookingBox">
        <page-header :iconsize="this.$screen.height>600?50:30" icon="hotel-receptionist">
          <template v-slot:title>ЗАПРОС НА БРОНИРОВАНИЕ</template>
          <template v-slot:text>
            <span  style="font-size: 20px; font-weight: lighter;">НОМЕР  </span>
            <span style="font-size: 20px; font-weight: bold; text-transform: uppercase">«{{$store.state.rooms[$store.state.bookingRoom].name}}»</span>
          </template>
        </page-header>
        <div v-if="sent" class="success">
          <p class="title">ВАША ЗАЯВКА УСПЕШНА ОТПРАВЛЕНА</p>
          <p class="subtitle">НОМЕР ВАШЕЙ БРОНИ</p>
          <p class="title" style="color: #4eb734 !important;">{{reservationNumber}}</p>
          <p class="subtitle">{{contactMessage}}</p>
        </div>

        <div v-if="!sent" class="form">
          <div class="pre">
            <p class="one">НА ДАННОМ ЭТАПЕ ОТ ВАС НЕ ТРЕБУЕТСЯ ВНОСИТЬ ОПЛАТУ ИЛИ ПРЕДОСТАВЛЯТЬ ДАННЫЕ БАНКОВСКОЙ КАРТЫ</p>
          </div>
          <div class="dates">
            <div class="date">
              <div class="label"><img class="icon" :src="require('@/assets/icons/date.png')"><p class="name">ДАТА ЗАЕЗДА</p></div>
              <v-date-picker color="yellow" :min-date='checkInMinDay' v-model="checkIn" :input-debounce="500">
                <template v-slot="{ inputValue, inputEvents }">
                  <input :class="{invalid:!inputValid.checkIn}" @focus="inputValid.checkIn=true, valid=true"  class="pickerInput bg-white borderrounded"
                         :value="inputValue" @click="inputValid.checkIn=true,valid=true"
                         v-on="inputEvents"
                         readonly
                  />
                </template>
              </v-date-picker>
            </div>

            <div class="date">
              <div class="label"><img class="icon" :src="require('@/assets/icons/date.png')"><p class="name">ДАТА ВЫЕЗДА</p></div>
              <v-date-picker  color="yellow" :min-date='checkOutMinDay' v-model="checkOut" :input-debounce="500">
                <template v-slot="{ inputValue, inputEvents }">
                  <input  :class="{invalid:!inputValid.checkOut}" @focus="inputValid.checkOut=true, valid=true" class="pickerInput bg-white borderrounded"
                          :value="inputValue" @click="inputValid.checkOut=true,valid=true"
                          v-on="inputEvents"
                          readonly
                  />
                </template>
              </v-date-picker>
            </div>
          </div>

          <!-- Поля для выбора количества гостей -->
          <div class="guests">
            <div class="guest-type">
              <div class="label"><img class="icon" :src="require('@/assets/icons/adult.png')"><p class="name">ВЗРОСЛЫЕ</p></div>
              <div class="counter">
                <button @click="changeGuestCount('adults', -1)" class="counter-btn" :disabled="adults <= 1">-</button>
                <span class="counter-value">{{adults}}</span>
                <button @click="changeGuestCount('adults', 1)" class="counter-btn" :disabled="adults >= 4">+</button>
              </div>
            </div>

            <div class="guest-type">
              <div class="label"><img class="icon" :src="require('@/assets/icons/kids.png')"><p class="name">ДЕТИ <span >(до 14)</span></p></div>
              <div class="counter">
                <button @click="changeGuestCount('children', -1)" class="counter-btn" :disabled="children <= 0">-</button>
                <span class="counter-value">{{children}}</span>
                <button @click="changeGuestCount('children', 1)" class="counter-btn" :disabled="children >= 4">+</button>
              </div>
            </div>
          </div>
          <div class="error">
            <p class="valid" v-if="valid && !submitError">УКАЖИТЕ АКТУАЛЬНЫЕ КОНТАКТНЫЕ ДАННЫЕ</p>
            <p v-if="!valid" class="invalidLabel">ЗАПОЛНИТЕ ВСЕ ПОЛЯ ОТМЕЧЕННЫЕ КРАСНЫМ</p>
            <p v-if="submitError" class="invalidLabel">{{ submitError }}</p>
          </div>
          <div class="client">
            <input @focus="inputValid.firstName=true, valid=true" placeholder="ВАШЕ ИМЯ" :class="{invalid:!inputValid.firstName}" class="pickerInput" v-model="firstName"/>
            <input @focus="inputValid.secondName=true, valid=true" placeholder="ВАШЕ ФАМИЛИЯ" :class="{invalid:!inputValid.secondName}"  class="pickerInput" v-model="secondName"/>
            <input @focus="inputValid.phone=true, valid=true" placeholder="НОМЕР ТЕЛЕФОНА" :class="{invalid:!inputValid.phone}" class="pickerInput" v-model="phone"/>
            <input @focus="inputValid.email=true, valid=true" placeholder="E-MAIL (НЕОБЯЗАТЕЛЬНО)" :class="{invalid:!inputValid.email}"  class="pickerInput" v-model="email"/>
          </div>

          <personal-data-consent-field v-model="consentAccepted" :show-error="consentError" @update:model-value="onConsentChange" />

          <div class="submit">
            <v-btn :block=true @click="sendMail" width="200" variant="contained-flat" :border="false"
                   :disabled="submitting"
                   :loading="submitting"
                   :style="{fontSize:$screen.width<375?'9px':'12px'} " height="40" size="small" color="primary">
              <span  style="color: white">{{ submitting ? 'ОТПРАВКА...' : 'ОТПРАВИТЬ' }}</span>
            </v-btn>

          </div>
          <div class="pre">
            <p class="two">УКАЖИТЕ ДАТЫ И СВОИ КОНТАКТНЫЕ ДАННЫЕ И НАШ МЕНЕДЖЕР СВЯЖЕТСЯ С ВАМИ ДЛЯ ПОДТВЕРЖДЕНИЯ НАЛИЧИЯ МЕСТ И ОТВЕТИТ НА ВСЕ ВАШИ ВОПРОСЫ</p>
          </div>
        </div>



      </div>

    </template>

  </modal-block>

</template>

<script>

  const axios = require('axios');
  import ModalBlock from "@/components/ModalBlock";
  import PageHeader from "@/components/PageHeader";
  import PersonalDataConsentField from "@/components/legal/PersonalDataConsentField";
  export default {
    name: 'ModalBooking',
    components: {PageHeader, ModalBlock, PersonalDataConsentField},
    data: () => ({
      checkIn:'',
      checkOut:'',
      checkInMinDay:'',
      checkOutMinDay:'',
      firstName:'',
      secondName:'',
      phone:'',
      email:'',
      sent:false,
      submitting:false,
      submitError:'',
      inputValid:{
        checkIn:true,
        checkOut:true,
        firstName:true,
        secondName:true,
        phone:true,
        email:true,
      },
      valid:true,
      reservationNumber:undefined,
      adults: 2,
      children: 0,
      consentAccepted: false,
      consentError: false,
    }),
    mounted() {
      this.checkInMinDay =this.$moment().add(1,'day').toDate();
      this.checkOutMinDay = this.$moment().add(3,'day').toDate();
    },
    beforeUnmount() {
      this.sent = false
      this.submitting = false
      this.submitError = ''
      this.reservationNumber = undefined
      this.consentAccepted = false
      this.consentError = false
    },
    computed: {
      currentRoom() {
        const room = this.$store.state.bookingRoom
        return Array.isArray(room) ? room[0] : room
      },
      // Сообщение в зависимости от московского времени
      contactMessage() {
        // Получаем текущее время в московском часовом поясе
        const moscowTime = new Date().toLocaleString("en-US", {timeZone: "Europe/Moscow"});
        const moscowHour = new Date(moscowTime).getHours();

        if (moscowHour >= 18 || moscowHour < 9) {
          return 'МЫ СВЯЖЕМСЯ С ВАМИ В НАЧАЛЕ РАБОЧЕГО ДНЯ С 9:00 ПО МОСКОВСКОМУ ВРЕМЕНИ';
        } else {
          return 'В БЛИЖАЙШЕЕ ВРЕМЯ С ВАМИ СВЯЖЕТСЯ НАШ МЕНЕДЖЕР';
        }
      }
    },
    methods:{
      sendMail(){
        if (this.submitting || this.sent) {
          return
        }

        let requestData = {
          roomType: this.currentRoom,
          checkIn:this.$moment(this.checkIn).format('YYYY-MM-DD'),
          checkOut:this.$moment(this.checkOut).format('YYYY-MM-DD'),
          firstName:this.firstName,
          secondName:this.secondName,
          phone:this.phone,
          email:this.email,
          adults: this.adults,
          children: this.children,
        }

        let valid = true
        let errors=0



        if(requestData.checkIn==='Invalid date'){this.inputValid.checkIn = false; errors++}
        if(requestData.checkOut==='Invalid date'){this.inputValid.checkOut = false; errors++}
        if(requestData.firstName.length<2){this.inputValid.firstName = false; errors++}
        if(requestData.secondName.length<2){this.inputValid.secondName = false; errors++}
        if(requestData.phone.length<2){this.inputValid.phone = false; errors++}

        if(!this.consentAccepted){this.consentError = true; errors++}

        if(errors>0){valid=false; this.valid=false}

        if(!valid){
          return
        }

        requestData.checkIn = requestData.checkIn + ' 12:00:00'
        requestData.checkOut = requestData.checkOut + ' 10:00:00'
        requestData.roomType = this.$store.state.rooms[requestData.roomType].name

        this.submitting = true
        this.submitError = ''

        axios.post(
          'https://d5digq4v5ghq1ofrtrbj.tmjd4m4j.apigw.yandexcloud.net/mailer',
          JSON.stringify({ data: requestData }),
          { headers: { 'Content-Type': 'text/plain;charset=UTF-8' } }
        ).then((response) => {
          const mailResult = response.data?.sentmail
          if (mailResult && mailResult.ok === false) {
            console.error('Booking mail failed:', mailResult.message)
            this.submitError = 'ЗАЯВКА НЕ ДОСТАВЛЕНА НА ПОЧТУ. ПОЗВОНИТЕ НАМ ИЛИ ПОПРОБУЙТЕ ПОЗЖЕ'
            return
          }

          this.reservationNumber = response.data.reservationNumber
          this.sent = true
        }).catch((error) => {
          console.error(error)
          this.submitError = 'НЕ УДАЛОСЬ ОТПРАВИТЬ ЗАЯВКУ. ПОПРОБУЙТЕ ЕЩЁ РАЗ ИЛИ ПОЗВОНИТЕ НАМ'
        }).finally(() => {
          if (!this.sent) {
            this.submitting = false
          }
        })
      },
      dateChange(picker){
        let minStay = 3
        if(picker==='checkIn'){
          if(this.checkOut!==''){
            let b = this.$moment(this.checkIn);
            let a = this.$moment(this.checkOut);
            let dif = a.diff(b, 'days')
            if(dif<minStay){this.checkOut =''}
          }
        }
      },
      changeGuestCount(type, amount) {
        if (type === 'adults') {
          this.adults = Math.max(1, Math.min(4, this.adults + amount));
        } else if (type === 'children') {
          this.children = Math.max(0, Math.min(4, this.children + amount));
        }
      },
      onConsentChange(value) {
        this.consentAccepted = value
        if (value) {
          this.consentError = false
        }
      }
    },
    watch:{
      checkIn() {this.dateChange('checkIn')},
      checkOut() {this.dateChange('checkOut')}
    }
  }
</script>

<style scoped>
  .invalid{
    border: 1px solid red;
  }

  .error{display: grid; text-align: center; height: 20px; font-size: 12px}
  .error>.invalidLabel{ font-size: 12px; color: red; font-weight: bold}

</style>

<style>

  #ModalBooking{max-width: 650px; width: 100%;}
  #ModalBooking.mobile{width: 100%; height: 100%; }
  .bookingBox{width: 100%;overflow: auto; position: relative}

  .bookingBox>.form>.pre{display: grid; padding: 0px 20px;font-size: 12px; text-align: center}
  .bookingBox>.form>.pre>.one{font-weight: bold; color: #23b301; font-size: 14px  }
  .bookingBox>.form>.pre>.two{padding-bottom: 10px}

  .bookingBox>.form>.dates{display: grid; grid-template-columns: 1fr 1fr; column-gap: 10px; padding: 20px ;padding-top: 10px; padding-bottom: 5px;}
  .bookingBox>.form>.dates>.date{display: grid; row-gap: 8px; padding-top: 10px;}
  .bookingBox>.form>.dates>.date>.label{grid-template-columns: auto auto; display: grid; column-gap: 8px; justify-content: center; width: 100%}
  .bookingBox>.form>.dates>.date>.label>.icon{height: 18px;}
  .bookingBox>.form>.dates>.date>.label>.name{font-size: 14px;}
  .bookingBox>.form>.dates>.date{}
  .pickerInput{width: 100%; height: 40px; text-align: center; background-color: white}
  .bookingBox>.form>.client{margin:10px 0px; display: grid; row-gap: 10px; padding: 20px; padding-top: 0px; padding-bottom: 0px; }
  .bookingBox>.form>.submit{padding: 20px; padding-top: 0px}
  .bookingBox>.success{display: grid; justify-items: center; padding: 20px}
  .bookingBox>.success>.title{font-weight: bold; font-size: 30px}
  .bookingBox>.success>.subtitle{ font-size: 20px}

  /* Гости */
  .guests {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    padding: 0px;
    padding-top: 0px;
    padding-bottom: 13px;
  }

  .guest-type {
    display: grid;
    row-gap: 8px;
    padding-top: 10px;
  }

  .guest-type .label {
    grid-template-columns: auto auto;
    display: grid;
    column-gap: 8px;
    justify-content: center;
    width: 100%;
  }

  .guest-type .label .icon {
    height: 18px;
  }

  .guest-type .label .name {
    font-size: 14px;
  }

  .counter {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .counter-btn {
    width: 50px;
    height: 40px;
    border: 1px solid #ccc;
    background-color: #f9f9f9;
    cursor: pointer;
    border-radius: 4px;
    font-size: 20px;
  }

  .counter-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .counter-value {
    font-size: 16px;
    font-weight: bold;
    min-width: 20px;
    text-align: center;
  }

</style>